import { FC, ReactNode, useMemo } from 'react'
import { Bold, Box, Center, HStack, Link, VStack } from '../index'
import { useSelector } from 'react-redux'
import { selectScenario, selectScenarioAdditionalInformation, selectScenarioId } from '../../state'
import { ScenarioProgressBar } from '../scenario-progress-bar'
import { Flex, Text } from '@chakra-ui/react'
import { isDev } from '../../environment'
import { LogoBrand } from '../logo-brand'
import i18next from 'i18next'
import { hostNameWithLocaleMap, ScenarioType } from '../../state/interfaces'
import { getLocale } from '../../i18n/locale'

export interface CenteredContentLayoutProps {
  headerLeft?: ReactNode
  headerRight?: ReactNode
  backgroundColor?: string
}

const domain = window.location.hostname

export const CenteredContentLayout: FC<CenteredContentLayoutProps> = ({
  children,
  headerLeft = null,
  headerRight = null,
}) => {
  // const { colorMode } = useColorMode()
  const scenarioId = useSelector(selectScenarioId)
  // const isLastStep = useSelector(selectIsLastStep)
  // const currentStep = useSelector(selectCurrentStep)
  const scenario = useSelector(selectScenario)
  const scenarioAdditionalInformation: Record<string, unknown> = useSelector(selectScenarioAdditionalInformation)

  // Force light mode: ignore any stored Chakra color mode (cookie/localStorage)
  const darkMode = ''

  // const background =
  //   isLastStep && colorMode === 'light' && currentStep!.id !== Steps.DECISION_MOBILE_INTERNET ? 'lightGreen' : ''

  const urlNeedsLocale = () => {
    const logoLabelLinkWithLocale = useMemo(() => hostNameWithLocaleMap[domain], [domain])
    if (logoLabelLinkWithLocale) {
      return true
    }
    return false
  }

  const locale = urlNeedsLocale() ? getLocale() : ''

  return (
    <Box minHeight="100vh">
      {/* <Box minHeight="100vh" backgroundColor={background}> */}
      <HStack
        position="relative"
        borderBottom="1px"
        borderBottomColor="gray"
        padding={2}
        alignItems="center"
        paddingX={10}
        height="20vw"
        maxHeight="100px"
        mt="1%"
      >
        {headerLeft}
        <Center padding="3" flex="1">
          <VStack>
            <Flex alignItems="center">
              {scenarioAdditionalInformation?.utmSource === 'finder' && (
                <Flex alignItems="center">
                  <Link href={`/${locale}`} mr={4}>
                    <LogoBrand domain={`${scenarioAdditionalInformation?.utmSource}${darkMode}`} />
                  </Link>
                  <Text ml={4} mt={6} fontSize={12} fontWeight={'bolder'}>
                    {i18next.t('common_by')}
                  </Text>
                </Flex>
              )}
              {scenario?.type === ScenarioType.ADVISE_INTERNET &&
                scenarioAdditionalInformation?.internetEstimationProvider && (
                  <Flex alignItems="center">
                    <Link href={`/${locale}`}>
                      <LogoBrand domain={`${scenarioAdditionalInformation?.internetEstimationProvider}`} />
                    </Link>
                    <Text ml={1} mt={6} fontSize={12} fontWeight={'bolder'}>
                      {i18next.t('common_by')}
                    </Text>
                  </Flex>
                )}
              <Link href={`/${locale}`}>
                <LogoBrand domain={domain} />
              </Link>
            </Flex>
            {isDev() && (
              <Text fontSize={'xxs'}>
                scenario: <Bold>{scenarioId}</Bold>
              </Text>
            )}
          </VStack>
        </Center>
        {headerRight}
      </HStack>
      <ScenarioProgressBar />
      <VStack
        alignItems="stretch"
        justifyContent="center"
        maxWidth="1200px"
        margin={{ base: '5vh auto 0', md: '10vh auto 0' }}
        padding="0 2px 40px 2px"
      >
        {children}
      </VStack>
    </Box>
  )
}
